import { Box, makeStyles, Theme, Typography } from '@material-ui/core';
import { IAdjustmentReadResourceV22, IBasketAdjustment } from 'components/basket/model/Basket';
import { isNumber, isString } from 'lib/typeInference';
import React from 'react';
import ClearIcon from '@material-ui/icons/Clear';
import { useCurrencyString } from 'lib/useCurrencyString';
import { addOpacity } from 'lib/helpers';
import { EGAEventName, useGAHelpers } from 'lib/useGAHelpers';

const useStyles = makeStyles((theme: Theme) => ({
    subtitle: {
        color: addOpacity(theme.palette.text.primary, 0.4),
        lineHeight: 1.35
    }
}));

interface CouponItemProps {
    adjustment: IAdjustmentReadResourceV22 | IBasketAdjustment;
    onClick: (couponCode: string) => void;
}

export const CouponItem: React.FC<CouponItemProps> = ({ onClick, adjustment }) => {
    const classes = useStyles();
    const { logUserEvent } = useGAHelpers();
    const handleClick = React.useCallback(() => {
        if (isString(adjustment.couponCode)) {
            onClick(adjustment.couponCode);
            logUserEvent(EGAEventName.CheckoutCouponRemoved);
        }
    }, [adjustment.couponCode, logUserEvent, onClick]);
    const getCurrencyString = useCurrencyString();
    return (
        <Box display="flex" justifyContent="space-between" key={adjustment.couponCode} py={1}>
            <Box>
                <Typography>{adjustment.description}</Typography>
                <Typography variant="body2" className={classes.subtitle}>
                    {adjustment.couponCode}
                </Typography>
                {isNumber(adjustment.value) && (
                    <Typography variant="body2" className={classes.subtitle}>
                        {getCurrencyString(adjustment.value)}
                    </Typography>
                )}
            </Box>
            <Box onClick={handleClick} pl={5} pr={1} display="flex" alignItems="center">
                <ClearIcon />
            </Box>
        </Box>
    );
};
